// One-time rename of a persisted key: the saved value moves to the new key unless one is already stored there, and
// the old key is cleared either way.
export default function moveLocalStorageKey(legacyKey: string, key: string) {
    if (typeof window === "undefined") {
        return
    }

    const legacyValue = window.localStorage.getItem(legacyKey)

    if (legacyValue !== null) {
        if (window.localStorage.getItem(key) === null) {
            window.localStorage.setItem(key, legacyValue)
        }

        window.localStorage.removeItem(legacyKey)
    }
}
